import {
  type ActionsDisplayMode,
  ITEMS_CONTAINER_ACTION_EDIT,
  ITEMS_CONTAINER_ACTION_ROW_CLICK,
  ITEMS_CONTAINER_ACTION_VIEW,
  type RowClickActions,
} from '@blaze-shared/elements-domain';

import { type BulkActionsDisplayMode, type RowActionsDisplayMode } from '../models/actions';

interface ViewRecordClickIntent {
  $type: 'view';
}

interface EditRecordClickIntent {
  $type: 'edit';
}

export interface CustomRecordClickIntent {
  $type: 'custom';
  aiDescription?: string;
}

export type RecordClickIntent =
  | ViewRecordClickIntent
  | EditRecordClickIntent
  | CustomRecordClickIntent;

export function toEngineActionsDisplayMode(style: RowActionsDisplayMode): ActionsDisplayMode {
  return style.$type;
}

export function toActionsDisplayModeStyle(mode: ActionsDisplayMode): RowActionsDisplayMode {
  return { $type: mode };
}

export function toEngineBulkActionsDisplayMode(style: BulkActionsDisplayMode): ActionsDisplayMode {
  return style.$type;
}

/** Bulk actions have no `hover` display mode */
export function toBulkActionsDisplayModeStyle(mode: ActionsDisplayMode): BulkActionsDisplayMode {
  return { $type: mode === 'hover' ? 'always' : mode };
}

export function toEngineRecordClickAction(intent: RecordClickIntent): RowClickActions {
  switch (intent.$type) {
    case 'view':
      return ITEMS_CONTAINER_ACTION_VIEW as RowClickActions;
    case 'edit':
      return ITEMS_CONTAINER_ACTION_EDIT as RowClickActions;
    case 'custom':
      return ITEMS_CONTAINER_ACTION_ROW_CLICK as RowClickActions;
  }
}

export function toRecordClickIntent(
  action: RowClickActions | undefined,
): RecordClickIntent | undefined {
  switch (action) {
    case ITEMS_CONTAINER_ACTION_VIEW:
      return { $type: 'view' };
    case ITEMS_CONTAINER_ACTION_EDIT:
      return { $type: 'edit' };
    case ITEMS_CONTAINER_ACTION_ROW_CLICK:
      return { $type: 'custom' };
    default:
      return undefined;
  }
}
